import React, { useState ,useEffect} from 'react'
import ManageDetail from '../ManageDetails/ManageDetail'
import ProfieCard from '../ProfileCard/ProfieCard'
import AdsDetails from '../AdsDetails/AdsDetails'
import { useDispatch ,useSelector} from 'react-redux'
import { fetchuserAds } from '../../features/User/UserAction'
import "./UserInfoCard.css"

export default function UserInfoCard() {

    const [adClick, setAdClick] = useState(false)
   const dispatch = useDispatch();
   const {BookWormUser} = useSelector((state) => state)
    const {userInfo} = BookWormUser
    
   useEffect(() => {
        
      dispatch(fetchuserAds({userId:userInfo._id}));

   },[])

  return (
    <div className="UserinfoCard">
          <ProfieCard setAdClick = {setAdClick} adClick = {adClick} />
         {
            !adClick && <ManageDetail />
         }    
         {
            adClick && <AdsDetails />
         }
          </div>
  )
}
